import { Flex } from "@chakra-ui/react";

const ContainerFlex = (props) => (
  <Flex
    position="relative"
    height="100%"
    width="100%"
    flexDirection="column"
    alignItems="center"
    justifyContent="space-between"
    {...props}
  />
);

const TopFlex = (props) => (
  <Flex flexShrink={0} flexDirection="column" alignItems="center" {...props} />
);

const CenterFlex = (props) => (
  <Flex
    flexGrow={1}
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    {...props}
  />
);

const BottomFlex = (props) => (
  <Flex flexShrink={0} alignItems="center" flexDirection="column" {...props} />
);

export const SceneLayout = ({
  top,
  center,
  centerProps,
  bottom,
  bottomProps,
  absolute,
  ...rest
}) => {
  return (
    <ContainerFlex {...rest}>
      {absolute}
      {top && <TopFlex>{top}</TopFlex>}
      <CenterFlex {...centerProps}>{center}</CenterFlex>
      <BottomFlex {...bottomProps}>{bottom}</BottomFlex>
    </ContainerFlex>
  );
};
